import { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('af_token');
    if (token) {
      authAPI.me()
        .then(r  => setUser(r.data.data))
        .catch(() => localStorage.removeItem('af_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const r = await authAPI.login({ email, password });
    localStorage.setItem('af_token', r.data.data.token);
    setUser(r.data.data.user);
    return r.data.data.user;
  };

  const logout = async () => {
    await authAPI.logout().catch(() => {});
    localStorage.removeItem('af_token');
    setUser(null);
    window.location.href = '/panel/login';
  };

  const isSuperAdmin = user?.role === 'super_admin';
  const isTenantAdmin = ['super_admin','tenant_admin','manager'].includes(user?.role);
  // Trial dá acesso a tudo; após assinar, respeita o plano contratado
  const hasFeature = (feat) =>
    user?.tenant_status === 'trial' ||
    user?.[feat] === 1  ||
    user?.[feat] === '1' ||
    user?.[feat] === true;

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isSuperAdmin, isTenantAdmin, hasFeature }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
